
import {
    ADD_LEAD_VIOLATION,
    ADD_LEAD_VIOLATION_SUCCESS,
    ADD_LEAD_VIOLATION_ERROR,
    UPDATE_LEAD_VIOLATION,
    UPDATE_LEAD_VIOLATION_SUCCESS,
    UPDATE_LEAD_VIOLATION_ERROR,
    DELETE_LEAD_VIOLATION,
    DELETE_LEAD_VIOLATION_SUCCESS,
    DELETE_LEAD_VIOLATION_ERROR,

} from "./actionTypes"
export const addLeadViolation = payload => {
    return {
        type: ADD_LEAD_VIOLATION,
        payload: payload,
    }
}

export const addLeadViolationSuccess = lead => {
    return {
        type: ADD_LEAD_VIOLATION_SUCCESS,
        payload: lead,
    }
}

export const addLeadViolationError = error => {
    return {
        type: ADD_LEAD_VIOLATION_ERROR,
        payload: error,
    }
}

export const updateLeadViolation = payload => {
    return {
        type: UPDATE_LEAD_VIOLATION,
        payload: payload,
    }
}

export const updateLeadViolationSuccess = lead => {
    return {
        type: UPDATE_LEAD_VIOLATION_SUCCESS,
        payload: lead,
    }
}

export const updateLeadViolationError = error => {
    return {
        type: UPDATE_LEAD_VIOLATION_ERROR,
        payload: error,
    }
}

export const deleteLeadViolation = payload => {
    return {
        type: DELETE_LEAD_VIOLATION,
        payload: payload,
    }
}

export const deleteLeadViolationSuccess = lead => {
    return {
        type: DELETE_LEAD_VIOLATION_SUCCESS,
        payload: lead,
    }
}

export const deleteLeadViolationError = error => {
    return {
        type: DELETE_LEAD_VIOLATION_ERROR,
        payload: error,
    }
}

  //Lead Violation//